import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.lean-planning')
  .factory('$planningRoutes', planRoutesObjectFactory);

function planRoutesObjectFactory($bringozFactory: $bringozFactory,
                                 PlanningRoutesAPI: BringozApi,
                                 LeanPlanningRoutes_DS: DataStoreConfig,
                                 Routes_PN: PushNotificationsConfig) {

  function $planningRoutes(id: string) {
    return $bringozFactory(id, PlanningRoutesAPI, LeanPlanningRoutes_DS, Routes_PN);
  }
  return $planningRoutes;
}
